<template>
  <div id="bscbing1">
    <div class="box">
      <div id="bscbing1div" style="height:100%"></div>
    </div>
  </div>
</template>

<script>
// 2：导入echarts
import echarts from 'echarts';
import { AREA_LIST, BU_LIST, MONTH_NAME } from '../mainPage/area_bu'

export default {
  name: 'bscbing1',
  data() {
    return {
      // 需要合并对象，样式
      legendColor: false,
      mm: 5,
      dataset: [
        [
          0.0341,
          0.0491,
          0.0297,
          0.0287,
          0.0227,
          0.0329,
          0.042,
          0.0387,
          0.0154,
          0.0151,
          0.0158,
          0.0443,
          0.0267
        ],
        [
          0.0277,
          0.0412,
          0.0401,
          0.027,
          0.0194,
          0.0439,
          0.0579,
          0.0487,
          0.0421,
          0.0284,
          0.0272,
          0.026,
          0.0274
        ],
        [
          0.0334,
          0.0483,
          0.0259,
          0.0323,
          0.0253,
          0.036,
          0.0476,
          0.0493,
          0.0421,
          0.0284,
          0.0272,
          0.0272
        ]
      ],
      NowYearTargetValue: [
        '1月',
        '2月',
        '3月',
        '4月',
        '5月',
        '6月',
        '7月',
        '8月',
        '9月',
        '10月',
        '11月',
        '12月'
      ]
    };
  },
  created() {},
  mounted() {
    //   mounted 函数表示已经DOM渲染完成
    this.NowYearTargetValue = []
    MONTH_NAME.forEach(x => {
      this.NowYearTargetValue.push(x.label)
    })
  },
  methods: {
    refreshChart(chartData) {
      const data1 = []
      const data2 = []
      const data3 = []
      const titleData = []
      this.dataset = []
      if (chartData !== undefined) {
        for (let i = 0; i < chartData.length; i++) {
          titleData.push(chartData[i].DisplayName)
          data1.push(chartData[i].LastYearPracticalValue)
          data2.push(chartData[i].PracticalValue)
          data3.push(chartData[i].PlanValue)
          this.NowYear = chartData[i].Year
        }
      }
      this.dataset = [data1, data2, data3]
      // this.NowYearTargetValue = titleData

      var myChart = echarts.init(document.getElementById('bscbing1div'));

      var option = {
        title: {
          text: this.locale('tce/¥10K(YOY)','万元产值综合能耗(YOY)'),
          textStyle: {
            color: '#fff',
            fontSize: 24
          },
          y: 10,
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: function(params) {
            var str = '';
            str += params[0].name;
            var now = new Date();
            for (var i = 0; i < params.length; i++) {
              str += '<br/>' + params[i].seriesName + ':' + params[i].value;
            }
            return str;
          }
        },
        legend: {
          x: 'right',
          y: 30,
          orient: 'vertical',
          textStyle: {
            color: '#ffffff',
            fontSize: 16
          },
          data: [
            '' + (this.NowYear - 1),
            '' + this.NowYear,
            this.locale('Target','目标')
          ]
        },
        grid: {
          left: '6%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.NowYearTargetValue,
            axisTick: {
              alignWithLabel: true,
              interval: 0
            },
            axisLabel: {
              interval: 0,
              color: '#ffffff',
              fontSize: 16
            },
            axisLine: {
              // 轴线
              lineStyle: {
                color: '#7f8fa4'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: this.locale('tce/¥10K','吨标煤/万元'),
            nameTextStyle: {
              color: '#ffffff',
              fontSize: 16
            },
            boundaryGap: [0, '10%'],
            axisLabel: {
              color: '#ffffff',
              fontSize: 16
            },
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#7f8fa4'
              }
            }
          }
        ],
        series: [
          {
            name: this.NowYear - 1,
            type: 'bar',
            itemStyle: {
              normal: {
                color: '#C1E7FD'
              }
            },
            barWidth: '30%',
            data: this.dataset[0],
            label: {
              color: '#eee'
            }
          },
          {
            name: this.NowYear,
            type: 'bar',
            itemStyle: {
              normal: {
                color: '#70DF00'
              }
            },
            barWidth: '30%',
            data: this.dataset[1]
          },
          {
            name: this.locale('Target','目标'),
            type: 'line',
            itemStyle: { normal: { color: '#1E90FF' } },
            barWidth: '30%',
            data: this.dataset[2],
            symbol: 'diamond'
          }
        ]
      };
      // 5：展示数据
      myChart.setOption(option);
    }
  }
};
</script>

<style lang="less" >
#bscbing1 {
  position: relative;
  width: 33%;
  height: 100%;
  background-color: rgba(6, 30, 93, 0.5);
  // border-top: 2px solid rgba(1, 153, 209, 0.5);
  box-sizing: border-box;
  margin-right: 10px;
  .box {
    height: 100%;
    width: 100%;
  }
}
</style>
